var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-app",
        { staticClass: "d-flex flex-column" },
        [
          _c("Header", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isLayoutHidden,
                expression: "!isLayoutHidden",
              },
            ],
          }),
          _vm._v(" "),
          _c("NoticeBar", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isLayoutHidden,
                expression: "!isLayoutHidden",
              },
            ],
          }),
          _vm._v(" "),
          _c(
            "v-main",
            {
              class: [
                "daon-main-wrap",
                { "daon-main-wrap--no-header": _vm.isLayoutHidden },
              ],
            },
            [
              _c("router-view", {
                key: ["ShopDetails", "ShopCoupons", "ShopProducts"].includes(
                  _vm.$route.name
                )
                  ? null
                  : _vm.$route.path,
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("Footer", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isFooterHidden,
                expression: "!isFooterHidden",
              },
            ],
            class: [{ "d-none": _vm.routerLoading }],
          }),
          _vm._v(" "),
          false ? _c("BottomChat") : _vm._e(),
          _vm._v(" "),
          _c("SidebarCart"),
          _vm._v(" "),
          _c("AddToCartDialog"),
          _vm._v(" "),
          !_vm.isAuthenticated ? _c("LoginDialog") : _vm._e(),
          _vm._v(" "),
          _c("SnackBar"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }